import { HeaderViewBgCornerHeight } from '@/pages/homepage/home_page_main/utils/constant';
import { HomePageLoganType, logan } from '@/pages/homepage/home_page_main/utils/Logan';

export const getElementByIdInElement = (element: any, id: string) => {
  if (!element) {
    return null;
  }
  if (element.hasChildNodes()) {
    const children = element.childNodes;
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      // ----- mpweb适配origin -----
      // if (child.getAttribute('id') === id) {
      // ----- mpweb适配change -----
      if (child.getAttribute && child.getAttribute('id') === id) {
      // ----- mpweb适配       -----
        return child;
      } else {
        const result = getElementByIdInElement(child, id);
        if (result) {
          return result;
        }
      }
    }
    return null;
  } else {
    return null;
  }
};

export const getElementById = (id: string) => getElementByIdInElement(document.body, id);

/**
     * 获取头部背景图的高度
     * @param bgHeight
     */
export const getHeaderViewBgHeight = (bgHeight: number, fitRatio: number) => {
  let height = 0;
  if (bgHeight) {
    const addressHeight = Mach.env?.navigationBarHeight + Mach.env?.statusBarHeight; // 地址栏高度
    const searchHeight = 56; // 搜索栏高度
    let promotionHeight = Mach.env?.screenWidth / 750 * 320; // 大促banner高度
    if (fitRatio && fitRatio > 0) { // 如有API下发比例，则使用下发比例
      promotionHeight = Mach.env?.screenWidth / fitRatio;
    }
    const cornerHeight = HeaderViewBgCornerHeight; // 圆角高度
    // 首页氛围高度适配
    if (bgHeight > 320) {
      // 状态栏 + 地址栏 + 搜索栏 + banner + 圆角高度
      height = addressHeight + searchHeight + promotionHeight + cornerHeight;
    } else {
      // 状态栏 + 地址栏 + 搜索栏 + 圆角高度
      height = addressHeight + searchHeight + cornerHeight;
    }
  }
  return height;
};

/**
     * 获取顶通宽高比例字段
     * @param item
     * @returns
     */
export const getFitRatio = (item) => {
  if (item && item?.json_data?.fitRatio) {
    const fitRatio: number = item?.json_data?.fitRatio;
    const newRatio = fitRatio.toFixed(2);
    return newRatio;
  }
  return null;
};

/**
     * 组装氛围数据
     * @param item
     * @returns
     */
export const getHeadBgComponentInfo = (item) => {
  if (item?.json_data?.headerBg) {
    const itemComponent = {
      data_id: '0o0mdIgPHlfJdFUKoHhx',
      builder_id: 'homeHeaderBackgroundBuilder_172_153',
      component_id: 'mach_pro_sailor_c_home_header_bg_sub',
      json_data: item?.json_data?.headerBg,
      layout_info: {
        margin_top: 0,
        margin_bottom: 0,
        margin_left: 0,
        margin_right: 0,
        padding_top: 0,
        padding_bottom: 0,
        padding_left: 0,
        padding_right: 0,
      },
      component_properties: {
        render_type: 'custom',
        stick_type: 0,
        top_type: 0,
        footer_type: 0,
        grid_info: null,
      },
      log_info: {
        cid: 'c_waimai_c_overseas_aatucy3n'
      }
    };
    return itemComponent;
  } else {
    logan(HomePageLoganType.Main, { msg: '天气氛围组件，headerBg为空,', componentInfo: item });
    return null;
  }
};

/**
     * 组装地址栏数据
     * @param item
     * @returns
     */
export const getAddressComponentInfo = (item) => {
  if (item?.json_data?.addressBar) {
    const itemComponent = {
      data_id: 'lVxqyQQqE5ma6rG3zbNb',
      builder_id: 'homeAddressBuilder_172_1',
      component_id: 'mach_pro_sailor_c_home_page_address_bar_sub',
      json_data: item?.json_data?.addressBar,
      layout_info: {
        margin_top: 0,
        margin_bottom: 0,
        margin_left: 0,
        margin_right: 0,
        padding_top: 0,
        padding_bottom: 0,
        padding_left: 0,
        padding_right: 0,
      },
      component_properties: {
        render_type: 'sub',
        stick_type: 1,
        top_type: 0,
        footer_type: 0,
        grid_info: null,
      },
      log_info: {
        cid: 'c_waimai_c_overseas_aatucy3n'
      }
    };
    return itemComponent;
  } else {
    logan(HomePageLoganType.Main, { msg: '天气氛围组件，addressBar为空,', componentInfo: item });
    return null;
  }
};

/**
     * 组装搜索栏数据
     * @param item
     * @returns
     */
export const getSearchComponentInfo = (item) => {
  if (item?.json_data?.searchBar) {
    const itemComponent = {
      data_id: 'kj1Nhp2lHQS9n4NQ9heL',
      builder_id: 'homeSearchBarBuilder_172_17',
      component_id: 'mach_pro_sailor_c_home_page_header_searchbar_sub',
      json_data: item?.json_data?.searchBar,
      layout_info: {
        margin_top: 0,
        margin_bottom: 0,
        margin_left: 0,
        margin_right: 0,
        padding_top: 0,
        padding_bottom: 0,
        padding_left: 0,
        padding_right: 0,
      },
      component_properties: {
        render_type: 'sub',
        stick_type: 1,
        top_type: 0,
        footer_type: 0,
        grid_info: null,
      },
      log_info: {
        cid: 'c_waimai_c_overseas_aatucy3n'
      }
    };
    return itemComponent;
  } else {
    logan(HomePageLoganType.Main, { msg: '天气氛围组件，searchBar为空,', componentInfo: item });
    return null;
  }
};

/**
     * 组装banner数据
     * @param item
     * @returns
     */
export const getBannerComponentInfo = (item) => {
  if (item?.json_data?.promotionBanner) {
    const itemComponent = {
      data_id: 'QizeMSgCIAdiRDVBDX44',
      builder_id: 'homeHeaderNoticeBuilder_172_15',
      component_id: 'mach_pro_sailor_c_home_page_promotion_banner_sub',
      json_data: item?.json_data?.promotionBanner,
      layout_info: {
        margin_top: 0,
        margin_bottom: 0,
        margin_left: 0,
        margin_right: 0,
        padding_top: 0,
        padding_bottom: 0,
        padding_left: 0,
        padding_right: 0,
      },
      component_properties: {
        render_type: 'custom',
        stick_type: 0,
        top_type: 0,
        footer_type: 0,
        grid_info: null,
      },
      log_info: {
        cid: 'c_waimai_c_overseas_aatucy3n'
      }
    };
    return itemComponent;
  } else {
    logan(HomePageLoganType.Main, { msg: '天气氛围组件，bannerInfo为空,', componentInfo: item });
    return null;
  }
};
